<template>
  <aside
    class="aliyun-ad"
    role="complementary"
    aria-label="广告"
    @click="handleClick"
    @keydown.enter.prevent="handleClick"
    @keydown.space.prevent="handleClick"
    tabindex="0"
  >
    <div class="aliyun-ad-badge">广告</div>
    <div class="aliyun-ad-brand">
      <span class="aliyun-ad-logo" aria-hidden="true">云</span>
      <span class="aliyun-ad-brand-name">阿里云</span>
    </div>
    <p class="aliyun-ad-title">新客专享云服务器优惠</p>
    <p class="aliyun-ad-desc">低至 ¥99/年，稳定可靠，即开即用</p>
    <span class="aliyun-ad-cta">立即查看</span>
  </aside>
</template>

<script>
export default {
  name: "AliyunPromo",
  methods: {
    handleClick() {
      window.open(
        "https://www.aliyun.com/minisite/goods?userCode=0qgiqsqi",
        "_blank",
        "noopener,noreferrer"
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.aliyun-ad {
  position: relative;
  margin-top: 15px;
  margin-bottom: 15px;
  padding: 16px 14px 14px;
  border-radius: 4px;
  overflow: hidden;
  cursor: pointer;
  color: var(--el-text-color-primary);
  background: var(--el-bg-color);
  outline: none;
}

.aliyun-ad-badge {
  position: absolute;
  top: 8px;
  right: 8px;
  padding: 1px 6px;
  border-radius: 3px;
  font-size: 10px;
  line-height: 16px;
  letter-spacing: 0.04em;
  color: var(--el-text-color-secondary);
  background: var(--el-fill-color-light);
}

.aliyun-ad-brand {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}

.aliyun-ad-logo {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 7px;
  font-size: 13px;
  font-weight: 700;
  color: #fff;
  background: #ff6a00;
}

.aliyun-ad-brand-name {
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.02em;
}

.aliyun-ad-title {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.35;
}

.aliyun-ad-desc {
  margin: 6px 0 0;
  font-size: 12px;
  line-height: 1.5;
  color: var(--el-text-color-secondary);
}

.aliyun-ad-cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-top: 12px;
  min-width: 88px;
  height: 30px;
  padding: 0 14px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 600;
  color: #fff;
  background: #ff6a00;
}
</style>
